import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContextMenuItem = _resolveComponent("ContextMenuItem")!
  const _component_ContextMenu = _resolveComponent("ContextMenu")!

  return (_openBlock(), _createBlock(_component_ContextMenu, {
    isVisible: _ctx.isVisible,
    position: _ctx.position,
    onClose: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ContextMenuItem, { onClick: _ctx.handleSelectAllChildrenByLevel }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("Отметить подчиненные по уровню", -1)
        ]))]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_ContextMenuItem, { onClick: _ctx.handleSelectAllChildren }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Отметить все подчиненные", -1)
        ]))]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_ContextMenuItem, { onClick: _ctx.handleUnselectAllChildren }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("Снять отметку с подчиненных", -1)
        ]))]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 8, ["isVisible", "position", "onClose"]))
}